// scroll to id smooth effect js start selector will be .scroll_too
document.addEventListener("DOMContentLoaded", function () {

  const offset = 120; // adjust based on your sticky header height

  document.querySelectorAll(".scroll_too").forEach(link => {

    link.addEventListener("click", function(e) {
      const targetId = this.getAttribute("href");

      if (targetId && targetId.startsWith("#")) {
        e.preventDefault();

        const target = document.querySelector(targetId);
        if (!target) return;

        const targetPosition =
          target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });

  });

});
// scroll to id smooth effect js end